import {
  backButton,
  mainButton,
  viewport,
  themeParams,
  miniApp,
  initData,
  locationManager,
  init as initSDK
} from '@telegram-apps/sdk-react';

/**
 * Initializes the application and configures its dependencies.
 */
export async function init(debug: boolean = false): Promise<void> {
  // Initialize special event handlers for Telegram Desktop, Android, iOS, etc.
  // Also, configure the package.
  initSDK();

  // Add Eruda if needed.
  debug &&
    import('eruda').then((lib) => lib.default.init()).catch(console.error);

  // Check if all required components are supported.
  if (!backButton.isSupported() || !miniApp.isSupported()) {
    throw new Error('ERR_NOT_SUPPORTED');
  }

  // Mount all components used in the project.
  backButton.mount();
  await miniApp.mount();
  await themeParams.mount();
  if (locationManager.isSupported()) void locationManager.mount();

  initData.restore();
  void viewport
    .mount()
    .catch((e) => {
      console.error('Something went wrong mounting the viewport', e);
    })
    .then(() => {
      viewport.bindCssVars();
    });

  if (!mainButton.isMounted()) mainButton.mount();

  mainButton.setParams({
    backgroundColor: '#000000'
  });

  if (mainButton.isVisible()) {
    mainButton.setParams({
      isVisible: false
    });
  }

  if (backButton.isVisible()) {
    backButton.hide();
  }

  // Define components-related CSS variables.
  miniApp.bindCssVars();

  if (miniApp.setBottomBarColor.isAvailable()) {
    miniApp.setBackgroundColor('#FFFFFF');
    miniApp.setBottomBarColor('#f5f5f5');
  }

  // themeParams.bindCssVars();
}
